export default {
  payment_statuses: []
}
